import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import styles from './Footer.module.css';

const Footer = ({ children }) => {
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerLinks}>
        <Link to="/privacy-policy">{t('privacyPolicy', 'Privacy Policy')}</Link>
        <Link to="/refund-policy">{t('refundPolicy', 'Refund Policy')}</Link>
        <Link to="/terms-and-policies">{t('termsAndPolicies', 'Terms & Policies')}</Link>
      </div>
      <div className={styles.footerCopyright}>
        {children || t('allRightsReserved', '© 2026 ReplyShoot – All Rights Reserved')}
      </div>
    </footer>
  );
};

export default Footer;
